exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._30_GD_TsxIFgf8sHAv0QiX{width:200px}", ""]);

// exports
exports.locals = {
	"dropdown": "_30_GD_TsxIFgf8sHAv0QiX"
};